import { H2 } from "components/atoms/H2";
import dayjs from "dayjs";
import Link from "next/link";
import { useRouter } from "next/router";
import { Avatar } from "shared/components/atoms/Avatar";
import { Typography } from "shared/components/atoms/Typography";
import { SampleChatRoom } from "shared/models";
import { toAmbiguousAge } from "shared/utils";
import { Paths } from "utils/routes";

interface Props {
  sampleChatRoom: SampleChatRoom;
  className?: string;
}

export const SampleChatRoomLink = ({ sampleChatRoom, className }: Props) => {
  const { query } = useRouter();
  const ambiguousAge = toAmbiguousAge(dayjs(sampleChatRoom.order.birthday));

  return (
    <div tw="mb-6 mx-5" className={className}>
      <H2 tw="mb-6">📩 実際の鑑定サンプル</H2>
      <Link href={Paths.fortuneTellers.sampleChatRoom(query.id)}>
        <a>
          <div tw="border border-solid border-theme rounded-xl p-2.5">
            <div tw="flex items-center mb-2.5">
              <Avatar src={sampleChatRoom.user?.imageUrl} size={20} blur={2} />
              <div tw="text-xs font-semibold text-theme ml-1.5">
                {sampleChatRoom.user?.name}・{ambiguousAge}代
                {sampleChatRoom.order.gender}
              </div>
            </div>
            <Typography
              tw="text-xs font-medium text-black leading-[19px] whitespace-normal inline-flex"
              maxLength={99}
              omission={<span tw="text-theme text-xs">もっとみる</span>}
            >
              {sampleChatRoom.order.consultContent}
            </Typography>
          </div>
        </a>
      </Link>
    </div>
  );
};
